import { FC } from "react";

import { isRawRow, SectionData } from "@/domain/view/components/datatable/datatable-types";
import { useDatatableContext } from "@/domain/view/components/datatable/use-datatable-context";
import { Row } from "@tanstack/react-table";

import { IndicatorListItem } from "../../../models/indicator-model";
import { IndicatorType } from "../../../models/indicator-type-model";
import { IndicatorTypeView } from "../../indicator-type-view";

export interface DatatableIndicatorTypeSectionHeaderProps {
  data: SectionData<IndicatorListItem>;
  currentRow: Row<SectionData<IndicatorListItem>>;
}

export const DatatableIndicatorTypeSectionHeader: FC<DatatableIndicatorTypeSectionHeaderProps> = ({ data }) => {
  const { table } = useDatatableContext<IndicatorListItem>();

  const rowModel = table.getFilteredRowModel();
  const filteredRows = rowModel.flatRows.filter((row) => {
    if (!isRawRow(row.original)) {
      return false;
    }
    return data.key === data.getSectionKey(row.original);
  });
  const count = filteredRows.length;

  return (
    <div className="flex h-full flex-row items-center justify-between gap-2 bg-foreground/[3%]  px-4">
      <div className="flex flex-row items-center justify-start gap-2  ">
        <IndicatorTypeView type={data.key as IndicatorType} />
        <span className="text-xs text-muted-foreground">{count}</span>
      </div>
      <div className="flex flex-row items-center justify-end"></div>
    </div>
  );
};
